import { BoldButton } from '@components/core-ui/form-elements/buttons/Button/variations/BoldButton';
import { useJobStatusActions } from 'app/hooks/useJobStatusActions';
import {
  showClaimButton,
  showMarkAsCompleteButton,
  showMarkAsEditedButton,
  showMarkAsProofreadButton,
} from '@pages/User/RepositoryPage/components/JobsTable/JobStatusActionsButton';
import { useAuthContext } from '@providers/AuthProvider';
import { JobResponseDto } from 'app/API';

type TProps = {
  job: JobResponseDto;
  reload: () => Promise<void>;
};

export const JobStatusActionsButton = ({ job, reload }: TProps) => {
  const { workspace, organization } = useAuthContext();
  const { claim, markAsComplete, markAsEdited, markAsProofread, isPending } = useJobStatusActions({
    workspaceId: workspace?.id || '',
    onSuccess: reload,
  });

  if (showClaimButton(job, organization)) {
    return (
      <div className="w-[200px] mr-4">
        <BoldButton className="w-[200px]" disabled={isPending} onClick={() => claim(job.id)} id="claim_job_button">
          Claim Job
        </BoldButton>
      </div>
    );
  }

  if (showMarkAsCompleteButton(job, organization)) {
    return (
      <BoldButton disabled={isPending} onClick={() => markAsComplete(job.id)} id="mark_as_complete">
        Mark As Complete
      </BoldButton>
    );
  }

  if (showMarkAsEditedButton(job, organization)) {
    return (
      <BoldButton disabled={isPending} onClick={() => markAsEdited(job.id)} id="mark_as_edited_button">
        Mark as Edited
      </BoldButton>
    );
  }

  if (showMarkAsProofreadButton(job, organization)) {
    return (
      <BoldButton disabled={isPending} onClick={() => markAsProofread(job.id)} id="mark_as_proofread">
        Mark as Proofread
      </BoldButton>
    );
  }

  return null;
};
